// Performance: completion, acceptance, response times and customer ratings.
const performance = {
  title: 'Performance',
  steps: ({ access }) => [
    {
      target: null,
      title: 'How the operation is doing',
      body: access.isOrg2
        ? 'Your completion rate, how quickly you accept offers, your arrival times against the ETA you gave, and what customers said about you by text.'
        : 'Completion and acceptance rates, response and arrival times, and the ratings customers send back by text, for the whole company or one provider or driver.'
    },
    {
      target: 'performance-dates',
      title: 'Pick a period',
      body: 'Start and end dates set the window for every number on the page.',
      placement: 'bottom'
    },
    {
      target: 'performance-controls',
      title: 'Facility and driver',
      body: 'Narrow the numbers to one facility or one driver. Leave both empty for the whole picture.',
      placement: 'bottom'
    },
    {
      target: 'performance-filter-toggle',
      title: 'More filters',
      body: 'Company name, region, service and vehicle class, when you need to compare slices of the business.',
      placement: 'bottom',
      when: (c) => !c.access.isOrg2
    },
    {
      target: 'performance-metrics',
      title: 'The cards',
      body: 'Each card is one measure with a short explanation under the ⓘ. Acceptance counts offers accepted out of all answered; timed-out offers count against it. Ratings come from the SMS survey sent after every completed job.',
      placement: 'top'
    },
    {
      target: null,
      title: 'Using it',
      body: 'Compare a provider against the company average before renewing their agreement, and watch acceptance rate after changing the dispatch radius or the offer timeout under Settings.'
    }
  ]
};

export default performance;
